import React from 'react';
import { client } from './client.js';
import { ApiClientContext } from './context.js';
export { useClient } from './context.js';
import { clientFactory } from './clientFactory.js';

const ApiClient = ({ children, client: client$1 = client, }) => {
    return (React.createElement(ApiClientContext.Provider, { value: React.useMemo(() => clientFactory(client$1), [client$1]) }, children));
};
ApiClient.displayName = 'ApiClient';

export { ApiClient };
//# sourceMappingURL=ApiClient.js.map
